module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-m",
      "header": false,
      "footer": false,
      "customClass": 'widthAuto'
    },
    on: {
      "close": function($event) {}
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.bodyClicked.apply(null, arguments)
      }
    },
    slot: "body"
  }, [(_vm.getIsGettingAgentInfo) ? _c('div', {
    staticClass: "loaderArea d-flex justify-content-center d-flex align-items-center w-100"
  }, [_c('div', [_c('loader')], 1)]) : (_vm.agent) ? _c('div', [_c('div', {
    staticClass: "p-3 row mx-0 agentInfoTop d-flex border-bottom-medium"
  }, [_c('div', {
    staticClass: "col-sm-5 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "imageHolder text-center w-100"
  }, [(_vm.agent.imageLogo) ? _c('img', {
    attrs: {
      "src": _vm.agent.imageLogo,
      "alt": ""
    }
  }) : _c('i', {
    staticClass: "fas fa-user dark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "darker fs-largest bold"
  }, [_vm._v(_vm._s(_vm.agent.brandName))]), _vm._v(" "), _c('div', {
    staticClass: "darker"
  }, [_vm._v(_vm._s(_vm.getAgentBusinessType(_vm.agent.role)) + " in " + _vm._s(_vm.agent.location) + ", " + _vm._s(_vm.agent.country.name))]), _vm._v(" "), (_vm.agent.registrationDate) ? _c('div', {
    staticClass: "dark fs-small"
  }, [_vm._v("with Pluralo since " + _vm._s(_vm.sinceDate(_vm.agent.registrationDate)))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "p-3 row bg-lighter darker mx-0 pt-4 radius-normal"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "fs-large bold mb-2"
  }, [_vm._v("Contact")]), _vm._v(" "), (_vm.agent.phone) ? _c('div', [_c('div', {
    staticClass: "fs-small"
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.agent.phtone
    }
  }, [_vm._v(_vm._s(_vm.agent.phone))])])]) : _vm._e(), _vm._v(" "), (_vm.agent.email) ? _c('div', [_c('div', {
    staticClass: "fs-small"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.agent.email
    }
  }, [_vm._v(_vm._s(_vm.agent.email))])])]) : _vm._e(), _vm._v(" "), (_vm.agent.website) ? _c('div', [_c('div', {
    staticClass: "fs-small"
  }, [_vm._v("Website")]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.cleanWebsite(_vm.agent.website)
    }
  }, [_vm._v(_vm._s(_vm.agent.website))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "fs-large bold mb-2"
  }, [_vm._v("Address")]), _vm._v(" "), (_vm.agent.address) ? _c('div', {}, [_vm._v("\n                        " + _vm._s(_vm.agent.address) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.agent.zip) ? _c('div', {}, [_vm._v("\n                        " + _vm._s(_vm.agent.zip) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_vm._v("\n                        " + _vm._s(_vm.agent.location ? _vm.agent.location + ',' : '') + " " + _vm._s(_vm.agent.country.name) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 pb-2 pt-3"
  }, [_c('button', {
    staticClass: "btn blue w-100",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Done")])])])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-d086789a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d086789a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/agentUnknownView.vue
// module id = 2286
// module chunks = 0